import { baseApiUrl, apiHeaders } from "@openimis/fe-core";

function getCsrfTokenLocal() {
  try {
    const t = localStorage.getItem("csrfToken");
    if (t) return t;
  } catch (e) {
    // ignore
  }

  try {
    const name = "csrftoken";
    const cookies = document.cookie ? document.cookie.split("; ") : [];
    const cookie = cookies.find((c) => c.startsWith(name + "="));
    return cookie ? cookie.split("=")[1] : null;
  } catch (e) {
    return null;
  }
}

export const SMS_LOGS_QUERY = `
  query OtpSmsLogsList {
    smsLogs(orderBy: ["-created_on"], first: 50) {
      edges {
        node {
          id
          phone
          insureeId
          insureeChfId
          claimUuid
          claimCode
          otpCode
          message
          status
          isSent
          createdOn
        }
      }
    }
  }
`;

export const fetchOtpSmsLogs = async () => {
  const headers = { ...apiHeaders() };
  const csrf = getCsrfTokenLocal();
  if (csrf) headers["X-CSRFToken"] = csrf;

  const response = await fetch(`${baseApiUrl}/graphql`, {
    method: "post",
    headers,
    body: JSON.stringify({ query: SMS_LOGS_QUERY }),
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const payload = await response.json();

  if (payload.errors && payload.errors.length) {
    throw new Error(payload.errors.map((e) => e.message).join("; "));
  }

  const edges = payload?.data?.smsLogs?.edges || [];
  return edges.map((edge) => edge.node);
};

export const SMS_LOG_DETAIL_QUERY = `
  query OtpSmsLogDetail($id: Int!) {
    smsLog(id: $id) {
      id
      uuid
      insureeId
      insureeChfId
      claimUuid
      claimCode
      phone
      otpCode
      message
      messageId
      clientReference
      scheduledAt
      createdAt
      messageCount
      smsFrom
      network
      smsType
      status
      isTest
      encryptMessage
      encryptKey
      apiResponse
      errorMessage
      isSent
      createdOn
      updatedOn
    }
  }
`;

export const fetchOtpSmsLogDetail = async (id) => {
  const headers = { ...apiHeaders() };
  const csrf = getCsrfTokenLocal();
  if (csrf) headers["X-CSRFToken"] = csrf;

  const response = await fetch(`${baseApiUrl}/graphql`, {
    method: "post",
    headers,
    body: JSON.stringify({ query: SMS_LOG_DETAIL_QUERY, variables: { id } }),
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const payload = await response.json();

  if (payload.errors && payload.errors.length) {
    throw new Error(payload.errors.map((e) => e.message).join("; "));
  }

  return payload?.data?.smsLog || null;
};

export const RESEND_SMS_LOG_MUTATION = `
  mutation ResendOtpSmsLog($id: Int!) {
    resendOtpSmsLog(id: $id) {
      success
      message
      smsLog {
        id
        status
        isSent
        messageId
        createdAt
        updatedOn
      }
    }
  }
`;

export const resendOtpSmsLog = async (id) => {
  const headers = { ...apiHeaders() };
  const csrf = getCsrfTokenLocal();
  if (csrf) headers["X-CSRFToken"] = csrf;

  const response = await fetch(`${baseApiUrl}/graphql`, {
    method: "post",
    headers,
    body: JSON.stringify({ query: RESEND_SMS_LOG_MUTATION, variables: { id } }),
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const payload = await response.json();

  if (payload.errors && payload.errors.length) {
    throw new Error(payload.errors.map((e) => e.message).join("; "));
  }

  return payload?.data?.resendOtpSmsLog;
};
